module.exports = __webpack_public_path__ + "img/app3.95ae3d24.png";